import { FlexBox } from "@brg/ui"
import { FC } from "react"
import { DesignerBorder, DesignerNameMob } from "shared/pages/projectEdit/ProjectAuthorsDisplay";
import styled from "styled-components";

const SectionWrapper = styled(FlexBox)`
  margin-left: 184px;
  flex-flow: column;
  flex-wrap: wrap;
`

export const ContextsSection: FC<{ value: string[], onClick: (val: string) => void }> = ({ value, onClick }) => {

    if (!value?.length) return null;

    return (
        <SectionWrapper className={'team-list-wrapper competition-section'}  offsetTop={16} width="100%" wrap="wrap" wrapMobile="wrap">
        {value?.map((i) => (
          <DesignerNameMob key={`item_${i}`} widthMobile={'100%'} isTeamEdit>

            <DesignerBorder isTeamEdit align={"center"}>
                <FlexBox className={'text-wrapper'} justifyMobile='space-between' alignMobile={'center'}>
                    {`${i}`}
                </FlexBox>
                <FlexBox className={'icon-wrapper'} offsetLeft={4} offsetLeftMobile={4} align='center' alignMobile='center'>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => onClick(i)}>
                      <path d="M4.99995 5.55234L1.65352 8.89877C1.51869 9.0336 1.29901 9.03437 1.16645 8.89732C1.13675 8.86661 1.1201 8.84878 1.11015 8.83771C0.980372 8.69332 0.970187 8.47732 1.10746 8.34004L4.44755 4.99995L1.10112 1.65351C0.966293 1.51869 0.966293 1.30009 1.10112 1.16526L1.16526 1.10112C1.30009 0.966293 1.51869 0.966293 1.65351 1.10112L4.99995 4.44755L8.34638 1.10112C8.48121 0.966293 8.69981 0.966294 8.83464 1.10112L8.89878 1.16526C9.0336 1.30009 9.0336 1.51869 8.89878 1.65351L5.55234 4.99995L8.89877 8.34638C9.0336 8.48121 9.03437 8.70089 8.89732 8.83345C8.86661 8.86315 8.84878 8.8798 8.83771 8.88975C8.69332 9.01953 8.47732 9.02971 8.34004 8.89243L4.99995 5.55234Z" fill="#909090" stroke="#909090" strokeWidth="0.4" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </FlexBox>
              </DesignerBorder>
          </DesignerNameMob>
        ))}
      </SectionWrapper>
    )
}import { FlexBox } from "@brg/ui"
import { FC } from "react"
import { DesignerBorder, DesignerNameMob } from "shared/pages/projectEdit/ProjectAuthorsDisplay";
import styled from "styled-components";

const SectionWrapper = styled(FlexBox)`
  margin-left: 184px;
  flex-flow: column;
  flex-wrap: wrap;
`

export const ContextsSection: FC<{ value: string[], onClick: (val: string) => void }> = ({ value, onClick }) => {

    if (!value?.length) return null;

    return (
        <SectionWrapper className={'team-list-wrapper competition-section'}  offsetTop={16} width="100%" wrap="wrap" wrapMobile="wrap">
        {value?.map((i) => (
          <DesignerNameMob key={`item_${i}`} widthMobile={'100%'} isTeamEdit>

            <DesignerBorder isTeamEdit align={"center"}>
                <FlexBox className={'text-wrapper'} justifyMobile='space-between' alignMobile={'center'}>
                    {`${i}`}
                </FlexBox>
                <FlexBox className={'icon-wrapper'} offsetLeft={4} offsetLeftMobile={4} align='center' alignMobile='center'>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => onClick(i)}>
                      <path d="M4.99995 5.55234L1.65352 8.89877C1.51869 9.0336 1.29901 9.03437 1.16645 8.89732C1.13675 8.86661 1.1201 8.84878 1.11015 8.83771C0.980372 8.69332 0.970187 8.47732 1.10746 8.34004L4.44755 4.99995L1.10112 1.65351C0.966293 1.51869 0.966293 1.30009 1.10112 1.16526L1.16526 1.10112C1.30009 0.966293 1.51869 0.966293 1.65351 1.10112L4.99995 4.44755L8.34638 1.10112C8.48121 0.966293 8.69981 0.966294 8.83464 1.10112L8.89878 1.16526C9.0336 1.30009 9.0336 1.51869 8.89878 1.65351L5.55234 4.99995L8.89877 8.34638C9.0336 8.48121 9.03437 8.70089 8.89732 8.83345C8.86661 8.86315 8.84878 8.8798 8.83771 8.88975C8.69332 9.01953 8.47732 9.02971 8.34004 8.89243L4.99995 5.55234Z" fill="#909090" stroke="#909090" strokeWidth="0.4" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </FlexBox>
              </DesignerBorder>
          </DesignerNameMob>
        ))}
      </SectionWrapper>
    )
}